import { optionsMap } from 'pro-gallery-lib';
export const VIDEO = {
  VOLUME: 'controllers_optionsMap_behaviourParams_item_video_volume'
};
export const VIDEO_CONTROLLERS = {
  [VIDEO.VOLUME]: value => {
    return {
      [optionsMap.behaviourParams.item.video.volume]: value ? 1 : 0
    };
  }
};
//# sourceMappingURL=video.js.map